import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import { useModalStore } from '@features/modal'
import { SBPPayment } from '@features/payment'
import { useAddPayment } from '@features/payment/hooks/useAddPayment'
import { useManagePaymentMethods } from '@features/payment/hooks/useManagePaymentMethods'

import { PAYMENT_TYPE_GPB, PAYMENT_TYPE_GPB_SBP, PaymentPluginId } from '@shared/contants'
import { getPaymentMethodLogo } from '@shared/lib/paymentMethodLogos.ts'
import Wrapper from '@shared/ui/wrapper'

import CardItem from './card-item/CardItem.tsx'
import Loader from './loader/Loader'
import { PaymentVerifier } from './payment-verifier/PaymentVerifier.tsx'

import styles from './styles.module.scss'


export default function PaymentMethods () {
  const { t } = useTranslation('personal')
  const { t: tp } = useTranslation('payment')

  const { paymentMethods, loading: isLoadingMethods } =
    useManagePaymentMethods()
  const { addPayment } = useAddPayment()
  const { openModal } = useModalStore()

  const isLoading = isLoadingMethods

  const handlePaymentTypeSelect = async (paymentPluginId: PaymentPluginId) => {
    const result = await addPayment(paymentPluginId)
    
    // Универсальная обработка на основе type
    if (result?.type === 'qr') {
      // QR код - показываем модалку
      openModal(
        'paymentQR',
        <SBPPayment
          qrUrl={result.qrUrl!}
          operationId={String(result.operationId)}
          verificationUrl={result.verificationUrl!}
        />,
        { title: paymentPluginId === PAYMENT_TYPE_GPB_SBP ? tp('sbp.bind_title') : tp('payment.bind_title') },
      )
    }
    // redirect уже произошел в useAddPayment
  }

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className={styles.root}>
      <Wrapper className={styles.root__wrapper}>
        <PaymentVerifier />
        <h2 className={styles.root__title}>{t('nav.payment')}</h2>
        {paymentMethods.length > 0 && (
          <div className={styles.root__cards}>
            {paymentMethods
              .filter((el) => el !== null)
              .map((el) => (
                <CardItem key={el.id} data={el} />
              ))}
          </div>
        )}

        <div className={styles.root__addButtons}>
          <button
            onClick={() => handlePaymentTypeSelect(PAYMENT_TYPE_GPB_SBP)}
            className={styles.root__addButton}
          >
            <img 
              className={styles.root__addButtonIcon} 
              src={getPaymentMethodLogo('sbp')}
              alt="SBP"
            />
            <span>{tp('sbp.bind_button')}</span>
          </button>

          <button
            onClick={() => handlePaymentTypeSelect(PAYMENT_TYPE_GPB)}
            className={styles.root__addButton}
          >
            <ReactSVG wrapper="span" src="/icons/card.svg" className={styles.root__addButtonIcon} />
            <span>{tp('card.bind_button')}</span>
          </button>
        </div>
      </Wrapper>
    </div>
  )
}
